import { PaintColor } from '@/data/types/ColorType';
import { SxProps } from '@mui/material';
import { PASTELES_FAMILY_COLOR } from 'shared/custom/constants/commonConstants';

export const buyByColorCardSx = {
	width: '100%',
	padding: 2,
	scrollMarginTop: '58px',
};

export const buyByColorCardTitleSx = {
	align: 'left',
	color: 'grey.500',
};

export const buyByColorAlertSx = {
	my: 1,
};

export const buyByColorBoxColorSelectedSx = {
	border: 1,
	borderColor: 'divider',
};

export const drawerSx = {
	zIndex: 1600,
	'& .MuiDrawer-paper': {
		width: {
			xs: 320,
			sm: 320,
			md: 360,
			lg: 360,
			xl: 360,
		},
		padding: 0,
		overflowX: 'hidden',
	},
};

export const containerSx = {
	height: '100vh',
	margin: 0,
	display: 'flex',
	flexDirection: 'column',
};

export const overflowContentSx = ({
	colorCodeSelected,
}: {
	colorCodeSelected: PaintColor | null;
}): SxProps => ({
	'&::-webkit-scrollbar': { display: 'none' },
	scrollbarWidth: 'none',
	msOverflowStyle: 'none',
	width: '100%',
	flexGrow: 1,
	overflowY: 'auto',
	pb: colorCodeSelected ? '140px' : '70px',
});

export const stickyBottomSx = {
	position: 'sticky',
	bottom: 0,
	width: '100%',
	bgcolor: 'background.paper',
	p: 2,
	borderTop: 1,
	borderColor: 'divider',
};

export const buyByColorDrawerContainerSx = {
	margin: '10px',
	border: 1,
	borderColor: 'divider',
};

export const buyByColorDrawerColorPaletteTitleSx = {
	display: 'flex',
	gap: '5px',
	cursor: 'pointer',
	padding: '10px',
};

export const rangeColorsTypographySx = {
	pl: '10px',
};

export const rangeColorsGridSx = {
	p: '10px',
	width: '100%',
	m: 0,
};

export const rangeColorsGridItemSx = ({ isEndOfRow }: { isEndOfRow: boolean }): SxProps => ({
	position: 'relative',
	pt: '0 !important',
	pl: '0 !important',
	pb: '10px',
	pr: isEndOfRow ? 0 : '10px',
});

export const colorSwatchBoxSx = ({
	isMobile,
	isSelected,
}: {
	isMobile: boolean;
	isSelected: boolean;
}): SxProps => ({
	width: isMobile ? 65 : 77.5,
	height: isMobile ? 65 : 75,
	cursor: 'pointer',
	'&:hover': {
		transform: !isMobile ? 'scale(1.1)' : '',
		backdropFilter: 'blur(10px)',
		boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
		borderRadius: '3.3',
	},
	...(isSelected && {
		backdropFilter: 'blur(10px)',
		boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
		borderRadius: '3.3',
	}),
});

export const colorSwatchUpperSectionSx = ({ color }: { color: PaintColor | null }): SxProps => ({
	width: '100%',
	height: '50%',
	backgroundColor: `rgb(${color?.R}, ${color?.G}, ${color?.B})`,
	border: `1px solid ${color?.name === PASTELES_FAMILY_COLOR ? 'grey.50' : 'transparent'}`,
});

export const colorSwatchLowerSectionSx = ({ color }: { color: PaintColor | null }): SxProps => ({
	width: '100%',
	height: '50%',
	backgroundColor: `rgba(${color?.R}, ${color?.G}, ${color?.B}, 0.2)`,
	border: `1px solid ${color?.name === PASTELES_FAMILY_COLOR ? 'grey.50' : 'transparent'}`,
	p: '5px',
});

export const colorSwatchTypography = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	width: '100%',
	display: 'inline-block',
};

export const checkCircleIconSx = ({
	isMobile,
	isEndOfRow,
}: {
	isMobile: boolean;
	isEndOfRow: boolean;
}): SxProps => ({
	position: 'absolute',
	top: isMobile ? '-5px' : '-10px',
	right: isMobile ? (isEndOfRow ? '-5px' : '4px') : isEndOfRow ? '-8px' : '0',
	width: isMobile ? 15 : 23,
	height: isMobile ? 15 : 23,
	backgroundColor: 'white',
	borderRadius: '50%',
});

export const colorCodeSelectedDrawerSx = {
	position: 'absolute',
	bottom: '0',
	width: '100%',
	maxHeight: '140',
	padding: '10',
};

export const colorCodeBorderSx = {
	backgroundColor: 'white',
	width: '100%',
	pt: '5px',
};

export const buyByColorDrawerTitleSx = {
	position: 'relative',
	p: '10px',
};

export const buyByColorDrawerTitleCloseSx = ({
	closeButtonAlign,
}: {
	closeButtonAlign: string;
}): SxProps => ({
	position: 'absolute',
	top: 0,
	px: '10px',
	color: 'grey.100',
	border: 'none',
	boxShadow: 'none',
	'&:hover': {
		border: 'none',
		boxShadow: 'none',
	},
	'&:focus': {
		outline: 'none',
	},
	...(closeButtonAlign === 'right' ? { right: 0 } : { left: 0 }),
});

export const buyByColorDrawerTitleDividerSx = {
	mb: '10px',
	mt: '5px',
};

export const drawerSubmitButtonSx = {
	mx: '10px',
	marginBottom: '10px',
	width: '95%',
};
